if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
  window.addEventListener('DOMContentLoaded', () => {
    var tab1_divider = "MAS_INFORMACION"
    var tab2_divider = "MODO_USO"
    var tab3_divider = "FORMULA"
    var resume = "";

    var description = document.getElementById('product-description-text');

	if (description) {

      resume = description.innerHTML;
      
      if (resume) {

        var description_container = document.querySelector('.js-description-tabs');

        var split = resume.split("[" + tab1_divider +"]");

        if(split[1])
        {
            // console.log(split);
            resume = ""
            resume += split[0];
            split = split[1].split("[/" + tab1_divider +"]")
            // console.log(split);
            resume += split[1]

            var desc_tab1_html = split[0];

            let desc_tab = document.getElementById("tab-mas-informacion");
            document.querySelector(".js-tab-mas-informacion").classList.remove("d-none");
            desc_tab.innerHTML = desc_tab1_html;

            description_container.classList.remove("d-none");
        }

        var split = resume.split("[" + tab2_divider +"]");

        if(split[1])
        {
            // console.log(split);
            resume = ""
            resume += split[0];
            split = split[1].split("[/" + tab2_divider +"]");
            resume += split[1];

            var desc_tab2_html = split[0];

            let desc_tab = document.getElementById("tab-modo-uso");
            document.querySelector(".js-tab-modo-uso").classList.remove("d-none");
            desc_tab.innerHTML = desc_tab2_html;
            description_container.classList.remove("d-none");
        }

        var split = resume.split("[" + tab3_divider +"]");


        if(split[1])
        {
            // console.log(split);
            resume = ""
            resume += split[0];
            split = split[1].split("[/" + tab3_divider +"]");
            resume += split[1];

            var desc_tab3_html = split[0];

            var desc_tab = document.getElementById("tab-formula");
            document.querySelector(".js-tab-formula").classList.remove("d-none");
            desc_tab.innerHTML = desc_tab3_html;
            description_container.classList.remove("d-none");
        }

        // console.log(resume)
        description.innerHTML = resume;

        document.querySelector(".js-mas-informacion").addEventListener("click", function(e) {
            e.preventDefault();

            let tabText = document.querySelector(".js-description-mas-informacion");

            if(tabText.classList.contains("d-none"))
            {
                tabText.classList.remove("d-none");
                document.querySelector(".js-icon-mas-informacion").textContent = "-"
            }
            else
            {
                tabText.classList.add("d-none");
                document.querySelector(".js-icon-mas-informacion").textContent = "+"
            }
        })

        document.querySelector(".js-modo-uso").addEventListener("click", function(e) {
            e.preventDefault();

            let tabText = document.querySelector(".js-description-modo-uso");

            if(tabText.classList.contains("d-none"))
            {
                tabText.classList.remove("d-none");
                document.querySelector(".js-icon-modo-uso").textContent = "-"
            }
            else
            {
                tabText.classList.add("d-none");
                document.querySelector(".js-icon-modo-uso").textContent = "+"
            }
        })

        document.querySelector(".js-formula").addEventListener("click", function(e) {
            e.preventDefault();

            let tabText = document.querySelector(".js-description-formula");

            if(tabText.classList.contains("d-none"))
            {
                tabText.classList.remove("d-none");
                document.querySelector(".js-icon-formula").textContent  = "-"
            }
            else
            {
                tabText.classList.add("d-none");
                document.querySelector(".js-icon-formula").textContent  = "+"
            }
        })
      }
    }
  });
}
